import React from 'react';
import Grid from '@mui/material/Grid';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';

import FormLabel from 'src/components/UI/input/CustomFormLabel';
import { useAutoTranslation } from 'src/hooks/useTranslate';

export default function RadioInput(props) {
  const {
    label,
    name,
    value,
    onChange,
    options,
    row,
    disabled,
    helperText,
    error
  } = props;

  const t = useAutoTranslation();

  return (
    <Grid
      container
      direction="column"
      spacing={1}
      sx={{
        justifyContent: 'flex-start',
        alignItems: 'flex-start'
      }}
    >
      <Grid>
        <FormLabel required={props.required}>{label}</FormLabel>
      </Grid>
      <Grid>
        <FormControl component="fieldset" error={error}>
          {/* Named by its label, in the reader's language; `name` is a field's
              code ("observed"), which a screen reader read out in English. */}
          <RadioGroup
            aria-label={
              typeof label === 'string' && label ? t(label) : undefined
            }
            name={name}
            value={value}
            onChange={onChange}
            row={row ?? undefined}
          >
            {options.map((el, i) => (
              <FormControlLabel
                key={i}
                disabled={disabled && el.value !== value ? true : undefined}
                value={el.value}
                control={<Radio size="small" />}
                label={t(el.label)}
              />
            ))}
          </RadioGroup>
          <FormHelperText>{helperText}</FormHelperText>
        </FormControl>
      </Grid>
    </Grid>
  );
}
